// extracted by mini-css-extract-plugin
module.exports = {"button":"_3Ud5Xj4jbAY-ir-X63XeZl","gray":"_9TZtnCor7lzCS7hwuPIQy","orange":"SrjHwkDem1tlKcgYnvDe_","green":"_1N09nUARgsmvm0UjI2mOGQ"};